window.xpv_settings = window.xpv_settings || {};
window.xpv_settings.limit_image_power_of_two = true;


document.addEventListener('DOMContentLoaded', function () {

    // Get elements
    const loadingScreen = document.getElementById('loading-screen');
    const loadingContainer = document.getElementById('loading-animation');
    const modalScreen = document.getElementById('modal-screen');
    const agreeCheckbox = document.getElementById('modal-agree-checkbox');
    const continueBtn = document.getElementById('modal-continue-btn');

    const urlParams = new URLSearchParams(window.location.search);
    const pattern = urlParams.get('pattern');

    let modalConfirmed = false; // Track if modal was confirmed

    // Load Lottie animation
    const animation = lottie.loadAnimation({
        container: loadingContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'https://lottie.host/d947e69b-e3bc-4a7e-b7a1-1468d650dbe3/nEwxXowTwY.json'
    });

    // Checkbox logic to enable/disable the Continue button
    if (agreeCheckbox && continueBtn) {
        agreeCheckbox.addEventListener('change', function () {
            if (this.checked) {
                continueBtn.classList.add('active');
                continueBtn.disabled = false;
            } else {
                continueBtn.classList.remove('active');
                continueBtn.disabled = true;
            }
        });

        continueBtn.addEventListener('click', function () {
            modalConfirmed = true;
            modalScreen.classList.remove('active');
            // Do NOT trigger loading screen manually here
        });
    }

    // Expivi onChange events
    expivi?._events?.onChange.subscribe(async (event) => {

        if (event.name === 'fully_loaded') {
            console.log('configurator is fully loaded.');

            if (pattern) {
                expivi.setProductAttributeByKey('left-shoe-key', pattern)
                    .then(() => {
                        return expivi.setProductAttributeByKey('right-shoe-key', {
                            image_source: pattern,
                            flipX: true,
                            rotation: -90
                        });
                    })
                    .catch((error) => {
                        console.error('Error applying pattern:', error);
                    });
            }

            expivi.setCameraTransform({
                position: {
                    x: 3.1737532911804487,
                    y: 2.5189928104891406,
                    z: 2.900129478707215
                },
                quaternion: {
                    w: 0.9112824969602332,
                    x: -0.2959819354528305,
                    y: 0.27228269487304146,
                    z: 0.08843663659475746
                },
                scale: {
                    x: -0.7151819793660638,
                    y: 0.4599481146800299,
                    z: 0.36799977796697697
                }
            });
        }

        if (event.name === 'attribute' && event.payload.attribute_key === "left-shoe-key") {
            expivi.setProductAttributeByKey('right-shoe-key', {
                ...event.payload.attribute_value,
                flipX: true,
                rotation: -event.payload.attribute_value.rotation,
                offset: [
                  -event.payload.attribute_value.offset[0],
                  event.payload.attribute_value.offset[1],
                ],
            });
        }

        if (event.name === 'media_download') {
            if (event?.payload?.source !== null && event?.payload?.loading === true) {
                console.log('image loading start');

                if (pattern) {
                    loadingScreen.classList.add('active');
                } else {
                    modalScreen.classList.add('active');
                }

            } else if (event?.payload?.source !== null && event?.payload?.loading === false) {
                console.log('image loading end');

                if (pattern) {
                    loadingScreen.classList.remove('active');
                } else if (modalConfirmed) {
                    modalScreen.classList.remove('active');
                }
            }
        }
    });
});


